function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_g_8_2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.41977 53V2.26H4.99977V53H2.41977ZM10.1598 53V2.26H12.7398V53H10.1598ZM15.3198 53V2.26H20.4798V53H15.3198ZM40.2665 53V2.26H42.8465V53H40.2665ZM45.4265 53V2.26H50.5865V53H45.4265ZM55.7465 53V2.26H58.3265V53H55.7465ZM78.1132 53V2.26H80.6932V53H78.1132ZM85.8532 53V2.26H88.4332V53H85.8532ZM93.5932 53V2.26H103.913V53H93.5932ZM115.96 53V2.26H118.54V53H115.96ZM121.12 53V2.26H126.28V53H121.12ZM131.44 53V2.26H134.02V53H131.44ZM153.807 53V2.26H156.387V53H153.807ZM166.707 53V2.26H169.287V53H166.707ZM171.867 53V2.26H177.027V53H171.867ZM191.653 53V2.26H194.233V53H191.653ZM199.393 53V2.26H209.713V53H199.393ZM214.873 53V2.26H217.453V53H214.873ZM229.5 53V2.26H232.08V53H229.5ZM237.24 53V2.26H239.82V53H237.24ZM244.98 53V2.26H255.3V53H244.98ZM267.347 53V2.26H269.927V53H267.347ZM275.087 53V2.26H277.667V53H275.087ZM280.247 53V2.26H285.407V53H280.247ZM305.194 53V2.26H315.514V53H305.194ZM320.674 53V2.26H323.254V53H320.674ZM328.414 53V2.26H330.994V53H328.414Z",
  fill: "white",
  fillOpacity: 0.5
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_g_8_2",
  x: 0.4198,
  y: 0.26001,
  width: 332.574,
  height: 54.74,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feTurbulence", {
  type: "fractalNoise",
  baseFrequency: "1.1111111640930176 1.1111111640930176",
  numOctaves: 3,
  seed: 6166
}), /*#__PURE__*/React.createElement("feDisplacementMap", {
  in: "shape",
  scale: 4,
  xChannelSelector: "R",
  yChannelSelector: "G",
  result: "displacedImage",
  width: "100%",
  height: "100%"
}), /*#__PURE__*/React.createElement("feMerge", {
  result: "effect1_texture_8_2"
}, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "displacedImage"
}))));
function SvgAerecurax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 55,
    viewBox: "0 0 333 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAerecurax);
export default __webpack_public_path__ + "static/media/aerecurax.9562a7f153bebd14c28cb7a73032a283.svg";
export { ForwardRef as ReactComponent };